module.exports = __webpack_public_path__ + "images/Tether_Studios-ba1b48fde7bcfca7a3331fdac08f1eab.png";